export default __webpack_public_path__ + "static/media/doctor-man-consulting-patient-while-filling-up-application-form-desk-hospital (1).2fb0a291.jpg";